import { render, staticRenderFns } from "./issuer.vue?vue&type=template&id=2bfd380e&scoped=true&"
import script from "./issuer.vue?vue&type=script&lang=js&"
export * from "./issuer.vue?vue&type=script&lang=js&"
import style0 from "./issuer.vue?vue&type=style&index=0&id=2bfd380e&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfd380e",
  null
  
)

export default component.exports